module.exports = __webpack_public_path__ + "static/media/1_pl.b94dd27f.png";